import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
export var DrillDownReportType;
(function (DrillDownReportType) {
    DrillDownReportType["Clicks"] = "clicks";
    DrillDownReportType["Leads"] = "leads";
    DrillDownReportType["Ftds"] = "ftds";
})(DrillDownReportType || (DrillDownReportType = {}));
export const DrillDownReportTypeMap = new Map([
    [DrillDownReportType.Clicks, 'Grid.Header.Clicks'],
    [DrillDownReportType.Leads, 'Grid.Header.Leads'],
    [DrillDownReportType.Ftds, 'Grid.Header.Ftds'],
]);
let DrillDownReportTypeService = class DrillDownReportTypeService {
    constructor(_translate) {
        this._translate = _translate;
        this._data = DrillDownReportTypeMap;
    }
    list() {
        return this._data;
    }
    get(key) {
        const k = this._data.get(key);
        return k ? this._translate.instant(k) : k;
    }
};
DrillDownReportTypeService.ctorParameters = () => [
    { type: TranslateService }
];
DrillDownReportTypeService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [TranslateService])
], DrillDownReportTypeService);
export { DrillDownReportTypeService };
